import File from './File';
import Segment from './Segment';

export default { File, Segment };
